<template>
	<section class="deal-checklist-item-container">
		<LoaderComponent v-show="isLoading"></LoaderComponent>

		<button
			:class="{ 'deal-checklist-item': true, hidden: isLoading }"
			@click="onItemClick"
		>
			<h2 class="item-description">{{ checklistItem.name }}</h2>

			<div class="ribbon-and-chevron">
				<p
					v-if="itemState !== 'UNVERIFIED'"
					class="status-ribbon"
					:style="{ backgroundColor: statusRibbonColor }"
				>
					{{ itemState }}
				</p>
				<span class="side-chevron" />
			</div>
		</button>
	</section>
</template>

<script>
	import DealChecklistItem from '@core/classes/Checklist/DealChecklistItem';
	import LoaderComponent from '@core/components/UI/LoaderComponent.vue';

	export default {
		name: 'CustomerChecklistItem',
		props: {
			dealId: String,
			checklistItem: DealChecklistItem,
			onUpdateItem: Function,
			onViewItem: Function,
		},
		data() {
			return {
				isLoading: false,
			};
		},
		computed: {
			itemState() {
				return this.checklistItem.getOverallStatus();
			},
			statusRibbonColor() {
				if (this.itemState === 'UNVERIFIED' || this.itemState === 'REJECTED') return 'var(--error-button-color)';
				if (this.itemState === 'PENDING') return 'var(--print-color)';
				return 'var(--success-button-color)';
			},
		},

		methods: {
			onItemClick() {
				if (this.itemState === 'PENDING' || this.itemState === 'APPROVED') this.onViewItem(this.checklistItem.id);
				else this.onUpdateItem(this.checklistItem.id);
			},
		},
		components: {
			LoaderComponent,
		},
	};
</script>
<style>
	.deal-checklist-item-container {
		position: relative;
		width: 100%;
		margin: 15px 0;
		border-radius: 10px;
		background-color: var(--main-color);
		box-shadow: 2px 3px 5px rgba(0, 0, 0, 0.5);
		transition: all 0.3s;
	}

	.deal-checklist-item-container:has(.deal-checklist-item:active) {
		box-shadow: unset;
	}

	.deal-checklist-item-container .spinner-container {
		position: absolute;
	}

	.deal-checklist-item {
		width: 100%;
		min-height: 100px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		background-color: transparent;
		border: none;
		color: var(--alt-text-color);
		transition: all 0.3s;
	}

	.deal-checklist-item.hidden {
		visibility: hidden;
	}

	.deal-checklist-item:hover {
		filter: brightness(1.3);
	}

	.deal-checklist-item .item-description {
		padding: 10px;
		text-align: left;
	}

	.deal-checklist-item .ribbon-and-chevron {
		display: flex;
		align-self: stretch;
	}

	.deal-checklist-item .ribbon-and-chevron:not(:has(.status-ribbon)) {
		border-left: 1px solid var(--light-main-text-color);
	}

	.deal-checklist-item .ribbon-and-chevron .status-ribbon {
		padding: 5px;
		align-self: stretch;
		border-left: 1px solid var(--light-main-text-color);
		writing-mode: vertical-lr;
		transform: rotate(180deg);
	}

	.deal-checklist-item .ribbon-and-chevron .side-chevron {
		align-self: center;
	}

	.deal-checklist-item .ribbon-and-chevron .side-chevron::before,
	.deal-checklist-item .ribbon-and-chevron .side-chevron::after {
		content: '';
		display: block;
		width: 30px;
		height: 5px;
		position: relative;
		right: 10px;
		transform-origin: right;
		background-color: var(--alt-text-color);
		border-radius: 10px;
	}

	.deal-checklist-item .ribbon-and-chevron .side-chevron::before {
		bottom: -4px;
		transform: rotate(70deg);
	}

	.deal-checklist-item .ribbon-and-chevron .side-chevron::after {
		top: -4px;
		transform: rotate(-70deg);
	}
</style>
